export function cn(...args) {
  const classes = [];

  args.forEach((arg) => {
    if (!arg) return;

    const argType = typeof arg;

    if (argType === "string" || argType === "number") {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      classes.push(cn(...arg));
    } else if (argType === "object") {
      Object.entries(arg).forEach(([key, value]) => {
        if (value) classes.push(key);
      });
    }
  });

  return classes.join(" ");
}

export function isLoggedIn() {
  return Boolean(
    localStorage.getItem("token") || localStorage.getItem("jwtToken")
  );
}

export const getToken = () =>
    localStorage.getItem("admintoken") ||
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("token");